import { render, staticRenderFns } from "./CreateRecommendation.vue?vue&type=template&id=46109f78&"
import script from "./CreateRecommendation.vue?vue&type=script&lang=js&"
export * from "./CreateRecommendation.vue?vue&type=script&lang=js&"
import style0 from "./CreateRecommendation.vue?vue&type=style&index=0&id=46109f78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports